var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"check-box",class:{ active: _vm.isChecked},on:{"click":function($event){$event.stopPropagation();return _vm.handleCheckBoxClick($event)}}},[_c('i',{staticClass:"far fa-check"})])}
var staticRenderFns = []

export { render, staticRenderFns }